import React from "react";
import getPublicAssetUrl from "utils/PublicAsset";

const TILE_WIDTH = 500;
const TILE_HEIGHT = 450;

const ICONS = [
    { src: getPublicAssetUrl("assets/icons/1.webp"), x: 20, y: 15, size: 55, rotate: -15 },
    { src: getPublicAssetUrl("assets/icons/5.webp"), x: 300, y: 10, size: 52, rotate: 12 },
    { src: getPublicAssetUrl("assets/icons/3.webp"), x: 150, y: 160, size: 48, rotate: -20 },
    { src: getPublicAssetUrl("assets/icons/2.webp"), x: 400, y: 150, size: 54, rotate: 18 },
    { src: getPublicAssetUrl("assets/icons/4.webp"), x: 50, y: 310, size: 50, rotate: 22 },
    { src: getPublicAssetUrl("assets/icons/1.webp"), x: 270, y: 330, size: 48, rotate: -10 },
    { src: getPublicAssetUrl("assets/icons/5.webp"), x: 430, y: 350, size: 45, rotate: -25 },
];

let cachedTileUrl: string | null = null;

function generateTile(): Promise<string> {
    if(cachedTileUrl) {
        return Promise.resolve(cachedTileUrl);
    }

    return new Promise((resolve) => {
        const canvas = document.createElement("canvas");
        canvas.width = TILE_WIDTH;
        canvas.height = TILE_HEIGHT;
        const ctx = canvas.getContext("2d");

        if(!ctx) {
            return;
        }

        let loaded = 0;
        const images: { img: HTMLImageElement; conf: typeof ICONS[0] }[] = [];

        ICONS.forEach((conf) => {
            const img = new Image();
            img.crossOrigin = "anonymous";

            img.onload = () => {
                images.push({ img, conf });
                loaded++;

                if(loaded === ICONS.length) {
                    for(const { img: loadedImg, conf: c } of images) {
                        ctx.save();
                        ctx.translate(c.x + c.size / 2, c.y + c.size / 2);
                        ctx.rotate((c.rotate * Math.PI) / 180);
                        ctx.drawImage(loadedImg, -c.size / 2, -c.size / 2, c.size, c.size);
                        ctx.restore();
                    }

                    cachedTileUrl = canvas.toDataURL();
                    resolve(cachedTileUrl);
                }
            };

            img.src = conf.src;
        });
    });
}

const BgPattern = () => {
    const [tileUrl, setTileUrl] = React.useState<string | null>(cachedTileUrl);

    React.useEffect(() => {
        if(!tileUrl) {
            generateTile().then(setTileUrl);
        }
    }, []);

    return (
        <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
            <div className="absolute inset-0 halo-overlay"></div>
            {tileUrl && (
                <div
                    className="absolute inset-0 bg-pattern-icons"
                    style={{ backgroundImage: `url(${tileUrl})` }}
                ></div>
            )}
        </div>
    );
};

export default BgPattern;
